import { render, staticRenderFns } from "./Pomodoro.vue?vue&type=template&id=4f437913&scoped=true&"
import script from "./Pomodoro.vue?vue&type=script&lang=js&"
export * from "./Pomodoro.vue?vue&type=script&lang=js&"
import style0 from "./Pomodoro.vue?vue&type=style&index=0&id=4f437913&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f437913",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VIcon,VTab,VTabs})
